// extracted by mini-css-extract-plugin
export var color_box = "mini_color_card-module--color_box--e9974";
export var copy_overlay = "mini_color_card-module--copy_overlay--9c237";
export var info = "mini_color_card-module--info--51c23";
export var mini_color_card_compact = "mini_color_card-module--mini_color_card_compact--eb9ed";
export var mini_color_card_wrapper = "mini_color_card-module--mini_color_card_wrapper--ab303";